export const load = () => ({
	title: 'Retrofit Replacement vs. Retrofit Attachment for Windows',
	showTitle: true,
});
